import { formatDate } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DATE_TIME_FORMAT, SAUDI_TIMEZONE } from '../global/date-formate-constant';

// Backend `converted_date()` returns "M/D/YYYY HH:mm:ss" with the UTC timezone stripped.
const CONVERTED_DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4}) (\d{1,2}):(\d{2})(?::(\d{2}))?$/;

@Pipe({
  name: 'saudiDateTime',
  standalone: false,
})
export class SaudiDateTimePipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(value?: string | null): string {
    if (!value) return '-';

    const converted = value.match(CONVERTED_DATE_PATTERN);
    const date = converted
      ? new Date(Date.UTC(+converted[3], +converted[1] - 1, +converted[2], +converted[4], +converted[5], +(converted[6] ?? 0)))
      : new Date(value);
    if (isNaN(date.getTime())) return value;

    return formatDate(date, DATE_TIME_FORMAT, this.locale, SAUDI_TIMEZONE);
  }
}
